export default {
    data() {
        return {
            showValidationError: false,
            reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/, // eslint-disable-line
            emailErrorTxt: 'Укажите корректный адрес электронной почты',
            captchaErrorTxt: 'Неправильно введены символы с картинки',
            phoneErrorTxt: 'Укажите корректный телефон',
            isSend: false,
            agreement: false
        };
    },
    methods: {
        showInpError(payload) {
            return this.showValidationError && !this.isValidInp(payload);
        },
        checkEmail() {
            this.form.EMAIL = this.form.EMAIL.trim();

            if (this.form.EMAIL !== '') {
                this.emailErrorTxt = 'Укажите корректный адрес электронной почты';
                return this.reg.test(this.form.EMAIL);
            }

            this.emailErrorTxt = 'Это поле обязательно к заполнению';
            return false;
        },
        checkPhone() {
            if (this.form.TELEPHONE.length) {
                this.phoneErrorTxt = 'Укажите корректный телефон';
                return this.form.TELEPHONE.length === 17;
            }

            this.phoneErrorTxt = 'Это поле обязательно к заполнению';
            return false;
        },
        checkAgreement() {
            return this.form.isCheck;
        },
        // проверка поля на соответствие (> 2 символов по умолчанию или иное)
        isValidInp(payload) {
            let res = null;
            switch (payload) {
                case 'EMAIL':
                    res = this.checkEmail();
                    break;
                case 'TELEPHONE':
                    res = this.checkPhone();
                    break;
                case 'agreement_id':
                    res = this.checkAgreement();
                    break;
                default:
                    res = this.form[payload].length ? this.form[payload].length >= 2 : this.form[payload];
                    break;
            }
            return res;
        },
        // проверка поля на не пустое
        isNotEmptyInp(payload) {
            return this.form[payload].length;
        },
        // если берётся значение из кастомного vue-комопнента, приводим его к нужному
        // нам виду
        setSelectValue(value, key) {
            this.form[key] = value;
        },
        // Сброс формы
        resetForm() {
            Object.entries(this.form).forEach(item => {
                this.form[item[0]] = typeof item[1] !== 'boolean' ? '' : false;
            });
            this.isSend = false;
            this.showValidationError = false;
            this.isSubmitting = false;
        },
        // валидация формы
        isFormValid() {
            let result = true;

            Object.entries(this.form).forEach(item => {
                if (result) {
                    result = this.isValidInp(item[0]);
                }
            });

            return result;
        }
    }
};
